import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import { turnitinEulaRequest, turnitinEulaSuccess, turnitinEulaFailure, turnitinRequest } from '../reducers/turnitin';

import { API_LINK } from '../../constants';
import moment from 'moment';

const API = `${API_LINK}api`;




function* turnitinEulaFunctionAxios() {
  const state = yield select(fullState => fullState);
  const {
    user,
    token,
  } = state.loginReducer;
  
  var data ='{"user_id": "'+user.userId+'","accepted_timestamp":"'+moment().format('YYYY-MM-DDTHH:mm:ss').toString()+'Z","language": "en-US"}';
 
  const response = yield call(() =>
    axios({
      method: 'post',
      url: API+'/assessor/tii_acceptEula',
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: `Bearer ${token}`,
      },
      credentials: 'same-origin',
      data: {
        tii_data: data
      },
    }),
  );

  return response;
}

function* workerTurnitinEulaSaga() {
  try {
   
    const response = yield call(turnitinEulaFunctionAxios);
    const responseFromTurnitinEula = response.data;
   
    if (response.status === 200) {
      yield put(turnitinEulaSuccess(responseFromTurnitinEula));
      yield put(turnitinRequest());
    }
    if (response.status === 201) {
      yield put(turnitinEulaFailure(responseFromTurnitinEula.message));
    }
  } catch (error) {
   
    yield put(turnitinEulaFailure(error.message));
  }
}

export function* watcherTurnitinEulaSaga() {
  yield takeLatest(turnitinEulaRequest().type, workerTurnitinEulaSaga);
}
